import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../style/orientationGuard.css';

const PHONE_QUERY = '(max-width: 768px)';
const LANDSCAPE_QUERY = '(orientation: landscape)';

function OrientationGuard() {
  const { t } = useTranslation();
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const update = () => {
      const isPhone = window.matchMedia(PHONE_QUERY).matches;
      const isLandscape = window.matchMedia(LANDSCAPE_QUERY).matches;
      setIsBlocked(isPhone && isLandscape);
    };

    update();

    const phoneMql = window.matchMedia(PHONE_QUERY);
    const landscapeMql = window.matchMedia(LANDSCAPE_QUERY);
    const handler = () => update();

    if (phoneMql.addEventListener) {
      phoneMql.addEventListener('change', handler);
      landscapeMql.addEventListener('change', handler);
    } else {
      phoneMql.addListener(handler);
      landscapeMql.addListener(handler);
    }

    window.addEventListener('orientationchange', handler);
    window.addEventListener('resize', handler);

    return () => {
      if (phoneMql.removeEventListener) {
        phoneMql.removeEventListener('change', handler);
        landscapeMql.removeEventListener('change', handler);
      } else {
        phoneMql.removeListener(handler);
        landscapeMql.removeListener(handler);
      }
      window.removeEventListener('orientationchange', handler);
      window.removeEventListener('resize', handler);
    };
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.classList.toggle('orientation-guard--active', isBlocked);
    }

    if (
      isBlocked &&
      typeof window !== 'undefined' &&
      window.screen?.orientation?.lock
    ) {
      window.screen.orientation.lock('portrait').catch(() => {});
    }
  }, [isBlocked]);

  if (!isBlocked) return null;

  return (
    <div className="orientation-guard" role="dialog" aria-live="polite">
      <div className="orientation-guard__content">
        <div className="orientation-guard__title">
          {t("orientationGuard.rotatePhone", { defaultValue: "Rotate your phone" })}
        </div>
        <div className="orientation-guard__text">
          {t("orientationGuard.portraitOnly", {
            defaultValue: "This app is available in portrait only.",
          })}
        </div>
      </div>
    </div>
  );
}

export default OrientationGuard;
